import moment from 'moment';

export interface DateTimePair {
  date?: Date;
  time?: Date;
}

export interface DateRangeInputs {
  start: DateTimePair;
  end: DateTimePair;
}

export const makeDateTime = ({ date, time }: DateTimePair) =>
  moment(date).set({ hour: time?.getHours(), minute: time?.getMinutes() });

export function formatDateRange({ start, end }: DateRangeInputs): string {
  const startMoment = makeDateTime(start);
  const endMoment = makeDateTime(end);
  const isSameDay = startMoment.isSame(endMoment, 'day');
  const dateFmt = 'YYYY-MM-DD';
  const timeFmt = 'HH:mm';

  if (isSameDay) return `${startMoment.format(dateFmt)} ${startMoment.format(timeFmt)} - ${endMoment.format(timeFmt)}`;

  return `${startMoment.format(`${dateFmt} ${timeFmt}`)} - ${endMoment.format(`${dateFmt} ${timeFmt}`)}`;
}
